// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'latoFont', 'latoFont Fallback'"},"className":"__className_ae554c","variable":"__variable_ae554c"};